import { useState } from "react";
import { useApp } from "../../../services/app-context";
import SideModal from "../../certifications/components/SideModal";
import { Tabs } from "../../../components/Tabs";
import dayjs from "dayjs";
import { GroupTagList } from "./MaterialTable";
import { bytesToKB } from "../sales-aid-modal/helperFunc";
import PdfViewer from "../../../components/PdfViewer";

const tabs = [
    {
        label: "Preview",
        value: "preview",
    },
    {
        label: "Details",
        value: "details",
    },
];

const DetailsInfo = ({ label, value }: { label: string; value: string | React.ReactNode }) => {
    return (
        <div className="flex items-center gap-6">
            <div className="text-gray-701 text-xs w-[120px] uppercase font-semibold">{label}</div>
            <div className="text-black-600 text-xs">{value}</div>
        </div>
    )
}

function DetailsTab({ file }: { file: any }) {
    const { tenantProfile } = useApp();
    const groups = tenantProfile?.groups || [];
    return (
        <div className="flex flex-col gap-8">
            <DetailsInfo label="File Name" value={file.file_name} />
            <DetailsInfo label="Document Code" value={file.code} />
            <DetailsInfo label="File Size" value={bytesToKB(file.bytes_size)} />
            <DetailsInfo label="Date Uploaded" value={dayjs(file.created_at).format("MMM DD, YYYY")} />
            <DetailsInfo label="Assigned Cohort" value={<GroupTagList groups={file?.groups ?? []} groupOptions={groups} />} />
            <DetailsInfo label="Uploaded By" value={file?.uploaded_by?.name || "-"} />
        </div>
    )
}


export const DocumentPreviewModal = ({
    onClose,
    isOpen,
    file,
}: {
    onClose: () => void;
    isOpen: boolean;
    file: any;
}) => {
    const [tab, setTab] = useState("preview");
    return (
        <SideModal
            show={isOpen}
            toggle={onClose}
            title={`${file.file_name}`}
            containerClass="flex flex-col !px-5"
        >
            <div className="flex flex-col gap-4">
                <div className="text-black-600 text-xs mt-1">Uploaded {dayjs(file.created_at).format("MMM DD, YYYY")}</div>
                <div className="relative border-b border-[#D5D5D5]">

                    <Tabs value={tab} onChange={setTab} tabs={tabs} />
                </div>
                <div className="w-full mt-2">
                    {tab === "preview" && <div className="h-[calc(100vh-200px)]">
                        <PdfViewer
                            fileId={file.id}
                            displayName={file.file_name}
                            showHeader={false}
                            wrapperClassName="!w-full !min-w-full !max-w-none"
                        />
                    </div>}
                    {tab === "details" && <DetailsTab file={file} />}
                </div>
            </div>
        </SideModal>
    );
};
